import React, { Component, Fragment } from 'react';

const makeHideable = InnerComponent => class extends Component {
  constructor(props) {
    super(props);
    this.state = { shown: true };
  }

  hide() {
    this.setState({ shown: false });
  }

  show() {
    this.setState({ shown: true });
  }

  render() {
    const {
      props,
      state: { shown },
    } = this;

    switch (shown) {
      case true:
        return <InnerComponent {...props} />;
      default:
        return <Fragment />;
    }
  }
};

export { makeHideable };

const Hideable = ({ children }) => makeHideable(<Fragment>{children}</Fragment>);

export default Hideable;
